import React from 'react';

function RecoverFvv() {
  return <div>RecoverFvv</div>;
}

export default RecoverFvv;
